import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Facebook from "../assets/facebook-3.svg";
import Instagram from "../assets/instagram-2.svg";
import WhatsApp from "../assets/whatsapp-logo-2-1.svg";
import AppleLogo from "../assets/logos app/apple-logo-svgrepo-com 1.svg";
import GooglePlayLogo from "../assets/logos app/google-play-store-svgrepo-com 1.svg";
import { getAppSettings } from "../api/api";
import "./footer.css";

export default function Footer() {
  const navigate = useNavigate();
  const [appSettings, setAppSettings] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const res = await getAppSettings();
        if (res.status === 200) setAppSettings(res.data.info || {});
      } catch (_) {}
    })();
  }, []);

  const year = new Date().getFullYear();

  const SocialIcons = () => (
    <>
      <a href={"https://www.facebook.com/profile.php?id=61589743468624"} target="_blank" rel="noreferrer" aria-label="Facebook">
        <img src={Facebook} alt="Facebook" width={34} height={34} loading="lazy" decoding="async" />
      </a>
      <a href={"https://www.instagram.com/zocotickets/"} target="_blank" rel="noreferrer" aria-label="Instagram">
        <img src={Instagram} alt="Instagram" width={34} height={34} loading="lazy" decoding="async" />
      </a>
      <a href={"https://api.whatsapp.com/send/?phone=5493813545650&text&type=phone_number&app_absent=0"} target="_blank" rel="noreferrer" aria-label="WhatsApp">
        <img src={WhatsApp} alt="WhatsApp" width={34} height={34} loading="lazy" decoding="async" />
      </a>
    </>
  );

  const defaultAppStoreLink = "https://apps.apple.com/us/app/zoco-tickets/id6758010461";
  const defaultPlayStoreLink = "https://play.google.com/store/apps/details?id=com.men7ar31.zocotickets";
  const organizerPortalLink = "https://organizador.zocotickets.com/";
  const appStoreLink = appSettings.appStoreLink || appSettings.app_store_link || appSettings.ios_link || appSettings.iosLink || defaultAppStoreLink;
  const playStoreLink = appSettings.playStoreLink || appSettings.play_store_link || appSettings.android_link || appSettings.androidLink || defaultPlayStoreLink;

  return (
    <footer className="footer footer-simple pading150">
      <div className="footer-hr" />

      <div className="footer-top">
        <div className="footer-brand-social">
          {appSettings.logo && (
            <img 
              className="footer-logo" 
              src={appSettings.logo} 
              alt="ZOCO" 
              width={120} 
              height={28} 
              loading="lazy" 
              decoding="async" 
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/event")}
            />
          )}
          <div className="footer-social">
            <SocialIcons />
          </div>
        </div>

        <div className="footer-apps">
          <a className="store-badge" href={appStoreLink} target="_blank" rel="noreferrer" aria-label="Descargar en App Store">
            <img src={AppleLogo} alt="" width={16} height={16} loading="lazy" decoding="async" />
            <span>App Store</span>
          </a>
          <a className="store-badge" href={playStoreLink} target="_blank" rel="noreferrer" aria-label="Descargar en Google Play">
            <img src={GooglePlayLogo} alt="" width={16} height={16} loading="lazy" decoding="async" />
            <span>Google Play</span>
          </a>
        </div>

      </div>

      <div className="footer-tagline">La única plataforma sin cargos por servicio ni por ticket</div>

      <div className="footer-social-mobile">
        <SocialIcons />
      </div>

      <nav className="footer-nav">
        <button type="button" onClick={() => navigate("/event")}>Eventos</button>
        <button type="button" onClick={() => navigate("/reservas")}>Reservas</button>
        <button type="button" onClick={() => (window.location.href = organizerPortalLink)}>Organizá tu evento</button>
        <button type="button" onClick={() => navigate("/privacypolicy")}>Política de Privacidad</button>
        <button type="button" onClick={() => navigate("/termsandcondition")}>Términos y Condiciones</button>
        <button type="button" onClick={() => navigate("/contact-us")}>¿Necesitás soporte?</button>
        <button type="button" onClick={() => navigate("/arrepentimiento")}>Botón de arrepentimiento</button>
      </nav>

      <div className="footer-copy">Copyright © ZOCO {year}</div>
    </footer>
  );
}
